import React from 'react'
import SearchesSideCard from '../account/searchesSideCard'
import { Link, useLocation } from 'react-router-dom';
import barrenPayLightLogo from '../../assets/images/barrenPay-LightLogo.png'
import MobileNav from '../account/mobilenav'
import Footer from '../ui/Footer'

function Layout(props) {
  const location = useLocation()
  const { window, children } = props;

  const setBgColor = (path) => {
    if (location.pathname === path) {
      return "bg-gray-700"
    }
  }

  return (
    <div className="flex flex-1 bg-gray-50">
      <div className="min-h-full h-screen sticky top-0 sideNav hidden bg-gray-900 md:flex md:w-64 md:flex-col">
        <div className="flex flex-col pt-3 overflow-y-auto">

          <div className="flex items-center flex-shrink-0 px-4">
            <Link to="/account">
              <a href="" title="" className="">
                <img className='lightLogo inline-flex' src={barrenPayLightLogo} alt="" srcset="" />
              </a>
            </Link>
          </div>

          <div className="flex flex-col justify-between flex-1 h-full mt-14">
            <div className="space-y-4">
              <nav className="flex-1 space-y-2">
                <div className='mx-4'>
                  <Link to="/account/cards/createnewcard">
                    <button
                      type="button"
                      className="inline-flex items-center justify-center w-full px-4 py-3 text-sm font-semibold leading-5 text-white transition-all 
                duration-200  bg-gray-900 border border-white rounded hover:bg-gray-600 font-pj focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                    >
                      <svg className="w-5 h-5 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                      New Card
                    </button>
                  </Link>
                </div>

                <Link to="/account">
                  <a title="" className={`flex items-center px-4 py-3 text-sm font-medium text-white transition-all duration-200 mt-2 hover:bg-gray-700 group ${setBgColor("/account")}`}>
                    <svg className="flex-shrink-0 w-5 h-5 mr-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                    Home
                  </a>
                </Link>

                <Link to="/account/cards">
                  <a title="" className={`flex items-center px-4 py-3 text-sm font-medium text-white transition-all duration-200 mt-2 hover:bg-gray-700 group ${setBgColor("/account/cards")}`}>
                    <svg className="flex-shrink-0 w-5 h-5 mr-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
                    </svg>

                    Cards
                  </a>
                </Link>

                <Link to="/account/cards/createnewcard">
                  <a title="" className={`flex items-center px-4 py-3 text-sm font-medium text-white transition-all duration-200 mt-2 hover:bg-gray-700 group ${setBgColor("/account/cards/createnewcard")}`}>
                    <svg className="flex-shrink-0 w-5 h-5 mr-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" />
                    </svg>

                    Create New Card
                  </a>
                </Link>

                <Link to="/account/dealsandoffers">
                  <a title="" className={`flex items-center px-4 py-3 text-sm font-medium text-white transition-all duration-200 mt-2 hover:bg-gray-700 group ${setBgColor("/account/dealsandoffers")}`}>
                    <svg className="flex-shrink-0 w-5 h-5 mr-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75" />
                    </svg>

                    Discount Deals and Offers
                  </a>
                </Link>

                <Link to="/account/settings">
                  <a title="" className={`flex items-center px-4 py-3 text-sm font-medium text-white transition-all duration-200 mt-2 hover:bg-gray-700 group ${setBgColor("/account/settings")}`}>
                    <svg className="flex-shrink-0 w-5 h-5 mr-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                      />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    Account Settings
                  </a>
                </Link>

                <Link to="/account/signout">
                  <a title="" className={`flex items-center px-4 py-3 text-sm font-medium text-white transition-all duration-200 mt-2 hover:bg-gray-700 group ${setBgColor("/account/signout")}`}>
                    <svg className="flex-shrink-0 w-5 h-5 mr-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
                    </svg>
                    Sign Out
                  </a>
                </Link>

              </nav>

              {/* <hr className="border-gray-700" /> */}
            </div>

            <div className="sideBarAnalyticsCard mx-4 text-center mt-10">
              <SearchesSideCard />
            </div>

            <div className="px-5 pb-8 mt-10">
              <div className="flex items-center space-x-6">
                <Link>
                  <a title="" className="text-xs font-medium text-gray-400 hover:text-white"> Privacy Policy </a>
                </Link>

                <Link>
                  <a href="" title="" className="text-xs font-medium text-gray-400 hover:text-white"> Terms of Service </a>
                </Link>
              </div>

              <Link>
                <p className="mt-4 text-xs font-medium text-gray-400 hover:text-white">© 2023 Barrenpay Inc</p>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col flex-1">
        <main>
          <MobileNav />
          <div className="py-6">
            <div className="px-4 mx-auto max-w-7xl sm:px-6 md:px-8">
              {children}
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

export default Layout